/** @jsxImportSource @emotion/react */
import {Dialog} from '@reach/dialog';
import styled from '@emotion/styled/macro';
import {IconButton} from './Button';
import { ReactComponent as CrossIcon } from '@common/assets/cross.svg';
import React from 'react';

type DialogTitleProps = {
  title: React.ReactNode;
  onClose?: () => void;
  showCloseButton?: boolean;
  customStyle?: any;
};
function DialogTitle({
  title,
  onClose,
  showCloseButton = true,
  customStyle = {},
}: DialogTitleProps) {
  return (
    <div
      css={{
        borderBottom: '1px solid #e9eced',
        paddingBottom: 16,
        fontSize: 18,
        fontWeight: 900,
        lineHeight: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...customStyle,
      }}
    >
      {title}
      {showCloseButton && (
        <IconButton
          onClick={onClose}
          data-test-id={'close-btn'}
          aria-label={'close-btn'}
        >
          <div css={{'& > svg': {fontSize: 18}}}>
            <CrossIcon />
          </div>
        </IconButton>
      )}
    </div>
  );
}
type DialogContentProps = {
  customStyle?: any;
};

const DialogContent = styled.div<DialogContentProps>(props => {
  const {customStyle = {}} = props;
  return {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '30px 15px 0px 15px',
    borderBottom: '1px solid #e9eced',
    marginBottom: 20,
    ...customStyle,
  };
});

type DialogFooterProps = {
  customStyle?: any;
};
const DialogFooter = styled.div<DialogFooterProps>(props => {
  const {customStyle = {}} = props;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    ...customStyle,
  };
});

export {DialogContent, DialogFooter, Dialog, DialogTitle};
